<template>
  <app-base-main
      :hasMagin="false"
      no-padding
      parentTable
      table-border-top
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          :isBr="false"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SP" @change="campaignSelectChange($event)" width="180px"></ad-campaign-select>
        <ad-group-select ref="groupSelect" v-model="groupIds" :marketId="marketId" :campaignId="campaignId" v-if="!inGroup" adType="SP"></ad-group-select>
        <gj-select
            v-model="filter.status"
            :options="AdProductEnum.SP.statusOptionNew"
            placeholder="状态"
        ></gj-select>
        <gj-select
            v-if="!inGroup"
            v-model="filter.targetType"
            :options="AdGroupEnum.SP.targetingTypeOption"
            placeholder="投放类型"
        ></gj-select>
        <gj-select
            v-if="false && !inCampaign && !inGroup"
            v-model="filter.type"
            :options="AdGroupEnum.SP.targetingTypeOption"
            placeholder="活动类型"
        ></gj-select>
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 'asin', text: 'ASIN'},
              {id: 'listingTitle', text: '商品标题'},
              {id: 'msku', text: 'MSKU'},
            ]"
        ></gj-select-input>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            :clearable="false"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSpCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              :helpName="helpName"
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/product/export" :download-params="globalParams"
          >
          <template #before>
            <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
          </template>
          </gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          @click="add">
        新增广告商品
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdProductEnum.SP.status.PAUSE)"
          @click="enable(selectedRows)">
        启用
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdProductEnum.SP.status.ENABLE)"
          @click="pause(selectedRows)">
        暂停
      </gj-button>
      <gj-button
          v-if="$permission('adsSpCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdProductEnum.SP.status.ENABLE, AdProductEnum.SP.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          :helpName="helpName"
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/product/export" :download-params="globalParams"
      >
      <template #before>
        <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
      </template>
      </gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSpCampaigns:addOrUpdate')"
          size="has-picture"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :pagination="pagination"
          show-summary :summary-object="sumRecord"
          sortable="custom"
          :show-header-overflow="true"
          :show-footer-overflow="true"
          :default-sort="defaultSort"
          :scroll-y="{mode: 'wheel', oSize:10, gt: 40 }"
          :selectable="notEqSelectable('state', AdProductEnum.SP.status.ARCHIVE)"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSpCampaigns:addOrUpdate')">
            <gj-tag
                v-if="row.state === AdProductEnum.SP.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :value="row.state === AdProductEnum.SP.status.ENABLE"
                @input="switchStatus($event, row)"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText(AdProductEnum.SP.statusOption)}}
          </template>
        </template>
        <template v-slot:listingTitle="{row}">
          <gj-tooltip
              :content="row.listingTitle"
              :text-line="1">
            {{row.listingTitle | defaultShow}}
          </gj-tooltip>
          <el-row>
            <el-col :span="12">
              <gj-tooltip
                  :content="row.asin">
                <div class="text-ellipsis-1">
                  <span class="gj-table--label">ASIN: </span>{{row.asin}}
                </div>
              </gj-tooltip>
            </el-col>
            <el-col :span="12">
              <gj-tooltip :content="row.msku">
                <div class="text-ellipsis-1">
                  <span class="gj-table--label">MSKU: </span>{{row.msku}}
                </div>
              </gj-tooltip>
            </el-col>
          </el-row>
        </template>
        <template v-slot:belongGroup="{row}">
          <app-sp-ad-route-link
              :ad-group-manager="{marketId, campaign: row, group: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.groupName">
              {{row.groupName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sp-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin, adDefaultSortMixin, adAdvancedFilteringMixin,
    currencySymbolMixin,
    inCampaignMixin,
    inGroupMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin, resizeMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {AdGroupEnum, AdProductEnum, AdLog} from "../../../common/enum";
  import {queryMixin, selectionMixin} from "@/minxins";
  import AppAddSpAdProduct from "../../common/modal/add/product/add-ad-product";
  import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
  import {subDays} from 'date-fns';
  import {convertToDate} from "@/utils/date.util";
  import {adStore} from "../../../common/store";
  import {getSpAdProductPage, updateSpAdProduct, SP} from "@/api/ad";
  import AppSpAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import AdGroupSelect from "modules/ad/common/components/ad-group-select.vue"
import AppAdLogModal from "../../../common/modal/log/ad-log-new-modal";
  import {LOG_OP_TYPE} from "../../../common/options";

  export default {
    name: "app-sp-ad-product",
    components: {AppSpAdRouteLink, AdCampaignSelect, AdGroupSelect},
    mixins: [
      inMarketMixin, inPortfolioMixin, resizeMixin,
      inCampaignMixin, inGroupMixin, tableNameMixin,
      selectionMixin, adBaseDataMixin, initDateMixin,
      queryMixin, currencySymbolMixin, adDefaultSortMixin, adAdvancedFilteringMixin
    ],
    created() {
      this.columns = [
        adFields.status,
        adFields.picture,
        adFields.listingTitle,
        {...adFields.servingStatus, options: AdProductEnum.SP.servingStatusOption},
        this.inGroup ? null : {...adFields.groupTargetType, options: AdProductEnum.SP.targetingTypeOption},
        this.inGroup ? null : adFields.belongGroup,
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.cvr,
        adFields.cpa,
        adFields.sales,
        // adFields.orderProductSales,
        adFields.acos,
        // adFields.acoas,
        // adFields.asoas,
        adFields.roas,
        // adFields.creationDate,
        adFields.op,
      ].filter(e => e !== null);
    },
    inject: [ 'getCornerMark' ],
    data() {
      return {
        helpName:'spadmanager',
        lastUpdatedDate: "",
        countryName: '',
        sumRecord: {},
        campaignIds: [],
        groupIds: [],
        tableData: [],
        columns: [],
        AdProductEnum: AdProductEnum,
        AdGroupEnum: AdGroupEnum,
        // filter
        filter: {
          status: AdProductEnum.SP.statusNew.ENABLE_PAUSE,
          targetType: null,
          type: null,
          keyword: {
            key: 1,
            value: null
          },
          extendSearch: null,
          date: [subDays(new Date(), 6), new Date()],
        },
        // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
        filterStoragekey: 'app-sp-ad-product',
        notStorage: true
      }
    },
    methods: {
      // 广告组修改
      async productEdit(param) {
        const params = {
          marketId: this.marketId,
          params: param
        }
        try {
          const { data, msg, isError} = await SP.productEdit(params);
          this.$gjMessage[isError ? 'error' : 'success'](msg);
          this.clearCheckboxRow();
          data && data.forEach(item => {
            let element = this.tableData.find(e => e.adId === item.adId);
            Object.assign(element, item);
          });
        } catch (error) {
          //
        }
      },
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          groupIds: [],
          filter: {
            status: AdProductEnum.SP.statusNew.ENABLE_PAUSE,
            type: null,
            targetType: null,
            keyword: {
              key: 'asin',
              value: null
            },
            extendSearch: null,
            date: this.initDate || [subDays(new Date(), 6), new Date()]
          },
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) return false;
        this.getCornerMark();
        this.getTablePage();
      },
      async getTablePage() {
        this.loading = true;
        // 处理广告活动 & 广告组
        let campaignIds = this.campaignIds || [];
        let groupIds = this.groupIds || [];
        this.campaignId && (campaignIds = [ this.campaignId ]);
        this.groupId && (groupIds = [ this.groupId ]);
        const params = {
          model: {
          campaignIds,
          groupIds,
          marketId: this.marketId,
          portfolioId: this.portfolioId,
          extendSearch: this.filter.extendSearch,
          states: this.filter.status ? JSON.parse(this.filter.status) : null,
          groupTargetingType: defaultVal(this.filter.targetType, null),
          startDate: convertToDate(this.filter.date[0]),
          endDate: convertToDate(this.filter.date[1]),
          [this.filter.keyword.key]: this.filter.keyword.value
        },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        try {
          let { data } = await SP.productPage(params);
          this.sumRecord = data.sumRecord;
          this.lastUpdatedDate = data.lastUpdatedDate;
          this.countryName = data.countryName;
          this.tableData = this.currencySymbolMixin(data.records, adStore.SP.currencySymbol);
          this.pagination = this.getPagination(data);
        } catch (error) {
          //
        } finally {
          this.loading = false;
        }
      },
      // 广告活动下拉改变
      campaignSelectChange(e) {
        this.groupIds = []
        let afferent = {
          campaignIds: e
        }
        this.$refs.groupSelect.getOptions('SP', afferent)
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      groupChange(groupId) {
        this.$gjNoticeQuery();
      },
      add() {
        this.$gjCreate(AppAddSpAdProduct, {
          props: {
            marketId: this.marketId,
            campaign: this.campaign,
            group: this.group
          },
          on: {
            created: () => {
              this.$gjMessage.success('创建成功');
              this.$gjResetPage();
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: `已选择 ${rows.length} 个广告商品，确认启用？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = rows.map(e => ({
                adId: e.adId,
                state: AdProductEnum.SP.status.ENABLE
              }))
              try {
                await this.productEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                //
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      pause(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: `已选择 ${rows.length} 个广告商品，确认停用？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = rows.map(e => ({
                adId: e.adId,
                state: AdProductEnum.SP.status.PAUSE
              }))
              try {
                await this.productEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                //
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = this.selectedRows.map(e => ({
                adId: e.adId,
                state: AdProductEnum.SP.status.ARCHIVE
              }))
              try {
                await this.productEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                //
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      viewLog(row) {
        let campaignId = this.campaignId || row?.campaignId;
        let groupId = this.groupId || row?.groupId;
        let objectName = row?.msku;
        this.$gjCreate(AppAdLogModal, {
          props: {
            campaignId,
            groupId,
            objectName,
            marketId: this.marketId,
            adType: 'SP',
            objectType: AdLog().objCell.commodity,
            name: isMeaningful(row) ? row.msku : '',
          }
        });
        // this.$gjCreate(AppAdLogModal, {
        //   props: {
        //     marketId: this.marketId,
        //     campaignId: this.campaignId,
        //     groupId: this.groupId,
        //     name: isMeaningful(row) ? row.asin : '',
        //     opId: isMeaningful(row) ? row.adId : null,
        //     adType: LOG_OP_TYPE.SP,
        //     object: LOG_OP_TYPE.SP.PRODUCT
        //   }
        // });
      }
    }
  }
</script>

<style scoped>

</style>
